document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form) {
    form.addEventListener('submit', function() {
      var button = form.querySelector('button[type="submit"]');
      if (button && !button.disabled) {
        button.dataset.originalText = button.textContent;
        button.textContent = 'Ajout au panier…';
      }
    });
  });
  document.querySelectorAll('.faq-item summary').forEach(function(summary) {
    summary.addEventListener('keydown', function(event) {
      if (event.key === ' ') event.preventDefault();
    });
  });
});
